// extracted by mini-css-extract-plugin
module.exports = {"image":"registerWelcome_image__8LjU5"};